module.exports = __webpack_public_path__ + "static/media/play.f16b2ebd.svg";